import { gate } from 'hub-http/gates';
import { useAuth } from 'framework-data-table/auth/context/AuthContext';
import withGateOverride from '../utils/withGateOverride';
export function useHasReorderingGate() {
  const {
    hasGate
  } = useAuth();
  return withGateOverride('CRM:Grid:NextDnDExperience', hasGate(gate('CRM:Grid:NextDnDExperience')));
}